var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.willHaveValue)?_c('span'):(_vm.value)?_c('span',[_vm._t("value",[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],2):_c('div',{staticClass:"line"})}
var staticRenderFns = []

export { render, staticRenderFns }